export default __webpack_public_path__ + "static/media/instagram.de1fd888.webp";